// extracted by mini-css-extract-plugin
export default {"footnote":"ClearKitForm_footnote__Hqv9P","placeHolderShimmer":"ClearKitForm_placeHolderShimmer__pSgxp"};